function stripTrailingEmpty(lines) {
  const copy = [...lines];
  while (copy.length > 0 && copy[copy.length - 1] === '') {
    copy.pop();
  }
  return copy;
}

/**
 * Compute the portion of remote live comment text that differs from local.
 * Returns null when there is nothing new to show as ghost text.
 */
export function computeLiveCommentDelta(localText = '', remoteText = '') {
  const local = localText ?? '';
  const remote = remoteText ?? '';

  if (!remote || remote === local) {
    return null;
  }

  const localLines = stripTrailingEmpty(local.split(/\r?\n/));
  const remoteLines = stripTrailingEmpty(remote.split(/\r?\n/));

  let sharedLines = 0;
  while (
    sharedLines < localLines.length &&
    sharedLines < remoteLines.length &&
    localLines[sharedLines] === remoteLines[sharedLines]
  ) {
    sharedLines += 1;
  }

  if (sharedLines >= remoteLines.length) {
    return null;
  }

  if (sharedLines < localLines.length && sharedLines < remoteLines.length) {
    const localLine = localLines[sharedLines];
    const remoteLine = remoteLines[sharedLines];

    if (remoteLine.startsWith(localLine) && remoteLine.length > localLine.length) {
      return {
        delta: remoteLine.slice(localLine.length),
        lineIndex: sharedLines,
        mode: 'inline',
      };
    }

    if (remoteLine !== localLine) {
      return {
        delta: remoteLine,
        lineIndex: sharedLines,
        mode: 'line',
      };
    }
  }

  if (sharedLines >= localLines.length) {
    const delta = remoteLines.slice(sharedLines).join('\n');
    if (delta) {
      return {
        delta,
        lineIndex: sharedLines,
        mode: 'append',
      };
    }
  }

  let prefixLength = 0;
  while (
    prefixLength < local.length &&
    prefixLength < remote.length &&
    local[prefixLength] === remote[prefixLength]
  ) {
    prefixLength += 1;
  }

  if (prefixLength < remote.length) {
    const delta = remote.slice(prefixLength);
    const lineIndex = local.slice(0, prefixLength).split('\n').length - 1;
    return {
      delta,
      lineIndex: Math.max(0, lineIndex),
      mode: 'suffix',
    };
  }

  return null;
}
